import type { FaireProductEntity } from "../../entity_types/product";

export const p_x8zn8z9mdw: FaireProductEntity = {
  token: "p_x8zn8z9mdw",
  type: "product",
  name: "Lighter Fluid -4 oz- 1 pc.",
  brandToken: "b_7j1sghpx",
  brandName: "Zippo Manufacturing Company",
  imageUrl: "https://cdn.faire.com/fastly/014ddfb880fd38f7a23ea7542e55fda7334ec497e9912993dfa2ac484f7a2ec9.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description: "Outdoor Premium Fuel 4 oz.  Consumers are always looking for lighter fluid.  Carry this accessory for additional sales.  ",
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:11.000Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
